module.exports = __webpack_public_path__ + "integration-wh-logo.png?efb94c57b893122a5a3b4650271c7d25";